import React from 'react';
import { Check, AlertCircle, AlertTriangle, Info } from 'lucide-react';

const ToastContainer = ({ toasts }) => (
  <div className="fixed top-24 right-4 md:right-8 z-[200] space-y-3 pointer-events-none max-w-[calc(100vw-2rem)]">
    {toasts.map(t => (
      <div key={t.id} className={`flex items-center gap-3 px-6 py-4 rounded-2xl shadow-2xl animate-in slide-in-from-right duration-300 border pointer-events-auto max-w-full ${
        t.type === 'success' ? 'bg-emerald-500 border-emerald-400 text-white' : 
        t.type === 'error' ? 'bg-red-500 border-red-400 text-white' :
        t.type === 'warning' ? 'bg-amber-500 border-amber-400 text-white' :
        'bg-slate-800 border-slate-700 text-white'
      }`}>
        {t.type === 'success' ? <Check className="w-5 h-5" /> : t.type === 'error' ? <AlertCircle className="w-5 h-5" /> : t.type === 'warning' ? <AlertTriangle className="w-5 h-5" /> : <Info className="w-5 h-5" />}
        <span className="font-bold text-sm">{t.message}</span>
      </div>
    ))}
  </div>
);

export default ToastContainer;
